import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/folders.vue
var o = {
	name: "DtIconFolders",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--folders"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Folders",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2.94 1.94A1.5 1.5 0 0 1 4 1.5h1.968a1.5 1.5 0 0 1 1.242.671l.413.604A.5.5 0 0 0 8.037 3H10a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 10 9H4c-.826 0-1.5-.674-1.5-1.5V3c0-.398.158-.78.44-1.06ZM4 2.5a.5.5 0 0 0-.5.5v4.5c0 .274.226.5.5.5h6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 10 4H8.032a1.5 1.5 0 0 1-1.242-.671l-.413-.604a.5.5 0 0 0-.414-.225H4Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M1 3.5a.5.5 0 0 1 .5.5v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1H2c-.826 0-1.5-.674-1.5-1.5V4a.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=folders.js.map